import { createPromiseClient } from '@bufbuild/connect-web';

import { transport } from '../transport';
import { StructureManager } from '@/generated/msh/service/v1/structure_manager_connectweb';
import { GetStructuresRequest } from '@/generated/msh/service/v1/structure_manager_pb';

const client = createPromiseClient(StructureManager, transport);

export async function fetchStructures(params, signal) {
  const response = await client.getStructures(
    new GetStructuresRequest(params),
    { signal }
  );

  return { structures: response };
}
